import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

import { useLogout } from "#modules/auth/infra/useLogout";
import { CompanyDto } from "#modules/company/infra/Company.dto";
import { useConnectUser } from "#modules/company/view/useConnectUser";
import { Icon } from "#shared/icons/Icon";
import { Center } from "#shared/view/components/Center";
import { Flex } from "#shared/view/components/Flex";
import { Text } from "#shared/view/components/Text";
import { Button } from "#shared/view/designSystem/Button";
import { TextInput } from "#shared/view/designSystem/inputs/TextInput";

interface onJoinExistingCompanyProps {
  handleCreateNewCompanyClick: () => void;
}

export function JoinExistingCompany({ handleCreateNewCompanyClick }: onJoinExistingCompanyProps) {
  const { logout } = useLogout();
  const { connectUser, isPending: isConnecting } = useConnectUser({
    onSuccess: async () => {
      await logout();
    },
  });
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<CompanyDto>();

  const { t } = useTranslation();

  const onConnectUser = async (data: { id: string }) => {
    connectUser(data.id);
  };

  return (
    <form onSubmit={handleSubmit(onConnectUser)} style={{ minWidth: 400 }}>
      <Center>
        <TextInput
          style={{ minWidth: 400 }}
          withAsterisk
          label={t("login.companyId")}
          error={errors.id ? t("login.companyIdRequired") : null}
          {...register("id", {
            required: true,
          })}
        />
      </Center>
      <Center>
        <Flex align="flex-start" style={{ width: 400 }} mt="xs">
          <Icon name="help" color={"grey"} />
          <Text size="xs" c="grey" inline ml="xs">
            {t("login.companyIdHelp")}
          </Text>
        </Flex>
      </Center>
      <Center>
        <Button mt="xs" size="md" loading={isConnecting} variant="filled" type="submit">
          {t("login.startQuoting")}
        </Button>
      </Center>
      <Center>
        <Link
          to="#"
          onClick={handleCreateNewCompanyClick}
          style={{ color: "black", fontSize: "12px", marginTop: 5 }}
        >
          {t("login.myCompanyDoesNotExist")}
        </Link>
      </Center>
    </form>
  );
}
